import * as React from 'react';

export default (props:any) => (
    <svg
        viewBox='0 0 24 24'
        {...props}
    >
        <polygon fill="none" points="0 0 24 0 24 24 0 24" />
        <polygon points="3 9 8 9 8 6 3 6" />
        <polygon points="9 6 9 17 20 17 20 6" />
        <polygon points="3 13 8 13 8 10 3 10" />
        <polygon points="3 17 8 17 8 14 3 14" />
    </svg>
)
